class Common {
  _init = async () => {
    _$.vue.$on("toplevel", status => {
      const { index } = __.common.tvWindowMetrics

      if (status && index) __.common.tvWindowBehind()
      else __.common._tvWindowSetSize()
    })

    return true
  }

  setTvWindowSize = async position => {
    position.width = Math.round(1.5 * position.width)
    position.height = Math.round(1.5 * position.height)
    position.y = Math.round(1.5 * position.y)
    position.x = Math.round(1.5 * position.x)

    if (__.media.hasPlayer() && __.media.player._player === "avplay") {
      webapis.avplay._setDisplayRects(position.x, position.y, position.width, position.height, position.index ? true : false)
      tizen.tvwindow.hide(() => {}, null, "MAIN")
    } else if (__.media.hasPlayer() && __.media.player._player === "rf") {
      tizen.tvwindow.show(() => {}, null, [position.x, position.y, position.width, position.height], "MAIN", position.index ? "FRONT" : "BEHIND")
      webapis.avplay._setDisplayRects(0, 0, 1, 1, false)
    } else if (!__.source.isPlatformSource()) {
      tizen.tvwindow.show(() => {}, null, [position.x, position.y, position.width, position.height], "MAIN", position.index ? "FRONT" : "BEHIND")
      webapis.avplay._setDisplayRects(0, 0, 1, 1, false)
    } else {
      tizen.tvwindow.hide(() => {}, null, "MAIN")
      webapis.avplay._setDisplayRects(0, 0, 1, 1, false)
    }
    return true
  }
}

export default Common
